import React, { useRef } from 'react';
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

const Title = () => {
    const titleRef = useRef(null);

    useGSAP(() => {
        const mm = gsap.matchMedia();
        mm.add('(prefers-reduced-motion: no-preference)', () => {
            const tl = gsap.timeline({ defaults: { ease: "expo.out", duration: 3 } });

            tl.fromTo("#title-first", { x: -50, autoAlpha: 0 }, { x: 0, autoAlpha: 1 }, "0")
                .fromTo("#title-last", { x: 50, autoAlpha: 0 }, { x: 0, autoAlpha: 1 }, "0")
                .fromTo("#hero-line", { scaleX: 0, transformOrigin: "center" }, { scaleX: 1 }, "0.2");
        });
    }, { scope: titleRef });

    return (
        <div ref={titleRef} className="w-full font-pp-neue px-4 mt-4">
            <h1 className={`leading-2 flex items-center justify-between whitespace-nowrap text-[9vw]`}>
                <span id="title-first">oppermann</span>
                <span id="hero-line" className="h-[3px] bg-black inline-block mx-4 w-[25vw]" ></span>
                <span id="title-last">kunst</span>
            </h1>
        </div>
    );
};

export default Title;